export default function Home() {
    return(
        <div className="Page">
            <h1>About</h1>
            <p> 
                I am currently a twelfth grader at Detroit Country Day school. 
            </p>
            <p>
                I enjoy doing competition math and competitive programming. I am also interested in theoretical math, particularly combinatorics. I post frequently 
                on the competition math website <a href="artofproblemsolving.com/community/user/404771" target="_blank">Art of Problem Solving</a>.
            </p>
            <p>
                I play the flute and I played the piano for a few years. My hobbies include, playing chess, playing tennis, and doing trivia puzzles. I also enjoy solving math and logic puzzles.
            </p>
        </div>
    )
}
